import React, { useState } from 'react';
import { CAlert, CBadge, CButton, CCard, CCardHeader, CCol, CDataTable, CRow } from '@coreui/react';
import { UserInfo, UserRoles } from '../../shared/models/user';
import EditProfileModal from '../containers/modals/EditProfileModal';
import ResetPasswordModal from '../../technicians/containers/modals/ResetPasswordModal';

const getUserTableData = (agent: UserInfo) => agent ? [{
  key: "ID",
  value: agent.id,
},{
  key: "Name",
  value: agent.displayName,
}, {
  key: "Email",
  value: agent.email,
}, {
  key: "Phone",
  value: agent.info.phone,
}, {
  key: 'Roles',
  value: agent.roles
}] : [];

export interface UserDetailsProps {
  user: UserInfo;
  // eslint-disable-next-line react/no-unused-prop-types
  profile: UserInfo;
  isLoading: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  onEdit: () => void;
  // eslint-disable-next-line react/no-unused-prop-types
  onRemove: (ids: number[]) => void;
}

const ProfileDetails = (props: UserDetailsProps) => {
  const { user, isLoading } = props;

  const [showEdit, setShowEdit] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const isAgent = user?.roles.indexOf(UserRoles.Agent) > -1 && user.roles.length === 1;

  const UserColumnRenderer = ({ key, value }) => {
    switch (key) {
      case 'Roles':
        return (value || []).map((role: string) => (
          <CBadge color="secondary mr-2" key={role}>{role}</CBadge>
        ));
      default:
        return (
          <strong>
            {value}
          </strong>
        );
    }
  };

  return (
    <CRow>
      <EditProfileModal profile={ user } show={ showEdit } close={ () => setShowEdit(false) } />
      <ResetPasswordModal show={showResetPassword} technician={user} close={() => setShowResetPassword(false)} />
      <CCol>
        {
          isAgent ? (
            <CAlert color="info">
              Please contact your Manager or Admin to get access to additional sections of Glympse Pro.
            </CAlert>

          ): null
        }
        <CCard className="glympser-container--roundedWithShadow mt-5 pt-3">
          <div className='glympser-roundedTop glympser-bottomBorder glympser-cardTitle'>Profile</div>
          <CCardHeader>
            <div className="card-header-actions">
              <CButton type="button" color="primary" className="mr-1 bg-color-orange border-0 roundedBtn" onClick={ () => setShowEdit(true) }>Edit</CButton>
              <CButton type="button" color="primary" className="mr-1 bg-color-orange border-0 roundedBtn" onClick={ () => setShowResetPassword(true) }>Reset Password</CButton>
            </div>
          </CCardHeader>
          <div className='job-list-container'>
            <CDataTable
              items={getUserTableData(user)}
              header={false}
              hover
              striped
              loading={isLoading}
              scopedSlots = {{
                'value':
                  (item) => <td>
                    {UserColumnRenderer(item)}
                  </td>
              }}
            />
          </div>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default ProfileDetails;
